import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["block", "className"],
  _excluded2 = ["type", "size", "className"],
  _excluded3 = ["form", "parentName", "name", "className", "children"],
  _excluded4 = ["buttonStyle", "size", "adjoined", "align", "block", "className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from 'antd';
import classNames from 'classnames';
import DixuForm from "../DixuForm/DixuForm";
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuInput from "../DixuInput/DixuInput";
import React from 'react';
const DixuCheckbox = _ref => {
  let {
      block,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-checkbox', {
    'dixu-checkbox--block': block
  }, className);
  return /*#__PURE__*/React.createElement(Checkbox, _objectSpread({
    className: classes
  }, rest));
};
DixuCheckbox.defaultProps = {
  block: false
};
const DixuCheckboxButton = _ref2 => {
  let {
      type,
      size,
      className
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-checkbox-button', {
    [`dixu-checkbox-button--type-${type}`]: type,
    [`dixu-checkbox-button--size-${size}`]: size
  }, className);
  return /*#__PURE__*/React.createElement(Checkbox, _objectSpread({
    className: classes
  }, rest));
};
DixuCheckboxButton.defaultProps = {
  type: 'solid',
  size: 'medium'
};
DixuCheckbox.Button = DixuCheckboxButton;
const DixuCheckboxButtonOther = _ref3 => {
  let {
      form,
      parentName,
      name,
      className,
      children
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  const classes = classNames('dixu-checkbox-button--other', className);
  const updateForm = _ref4 => {
    let {
      inputValue
    } = _ref4;
    if (inputValue) {
      // add OTHER to parent field value if not exists
      const parentValue = form.getFieldValue(parentName) || [];
      if (!parentValue || !parentValue.includes('OTHER')) {
        form.setFields([{
          name: parentName,
          value: [...parentValue, 'OTHER'],
          touched: true
        }]);
      }
    }
    if (!inputValue) {
      // remove OTHER from parent field value
      const parentValue = form.getFieldValue(parentName);
      form.setFields([{
        name: parentName,
        value: parentValue.filter(v => v !== 'OTHER'),
        touched: true
      }]);
    }
  };
  return /*#__PURE__*/React.createElement(DixuForm.Item, {
    noStyle: true,
    shouldUpdate: name
  }, () => {
    return /*#__PURE__*/React.createElement(DixuCheckbox.Button, _objectSpread(_objectSpread({
      className: classes
    }, rest), {}, {
      value: 'OTHER'
    }), /*#__PURE__*/React.createElement("span", {
      className: "inline-block",
      style: {
        marginBottom: -4
      }
    }, /*#__PURE__*/React.createElement(DixuRow, {
      align: "middle",
      gutter: [8, 8]
    }, /*#__PURE__*/React.createElement(DixuCol, null, children), /*#__PURE__*/React.createElement(DixuCol, {
      flex: "1 1 auto"
    }, /*#__PURE__*/React.createElement(DixuForm.Item, {
      name: name,
      noStyle: true
    }, /*#__PURE__*/React.createElement(DixuInput, {
      size: "small",
      onChange: event => {
        const {
          target: {
            value
          }
        } = event;
        updateForm({
          inputValue: value
        });
      }
    }))))));
  });
};
DixuCheckboxButtonOther.defaultProps = {};
DixuCheckboxButton.Other = DixuCheckboxButtonOther;
const DixuCheckboxGroup = _ref5 => {
  let {
      buttonStyle,
      size,
      adjoined,
      align,
      block,
      className,
      children
    } = _ref5,
    rest = _objectWithoutProperties(_ref5, _excluded4);
  const classes = classNames('dixu-checkbox-group', {
    'dixu-checkbox-group--adjoined': adjoined,
    [`dixu-checkbox-group--align-${align}`]: align,
    'dixu-checkbox-group--block': block
  }, className);
  const mappedChildren = React.Children.map(children, child => {
    if (buttonStyle && [DixuCheckboxButton, DixuCheckboxButtonOther].includes(child.type)) {
      const {
        props
      } = child;
      const addedProps = {
        size,
        type: buttonStyle
      };
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, props), addedProps));
    }
    return child;
  });
  return /*#__PURE__*/React.createElement(Checkbox.Group, _extends({
    className: classes
  }, rest), mappedChildren);
};
DixuCheckboxGroup.defaultProps = {
  buttonStyle: undefined,
  size: undefined,
  adjoined: false,
  align: undefined,
  block: false
};
DixuCheckbox.Group = DixuCheckboxGroup;
export default DixuCheckbox;